var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanderConceptIconPanels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 14.8533H21.3335",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 14.8533H2.6665",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.85343V4.18677",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9868 9.20007L20.8801 7.32007",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 7.32007L7.6798 9.20007",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 17.52L2.6665 28.1867H26.6665L29.3332 17.52H5.33317Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.8533H28",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 17.52L10.6665 28.1867",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 17.52L18.6665 28.1867",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9333 17.5201C18.4087 16.7099 18.6617 15.7885 18.6666 14.8492C18.6715 13.9098 18.4283 12.9858 17.9614 12.1707C17.4946 11.3555 16.8208 10.6781 16.0081 10.207C15.1954 9.7359 14.2727 9.48779 13.3333 9.48779C12.394 9.48779 11.4713 9.7359 10.6586 10.207C9.84589 10.6781 9.17204 11.3555 8.70521 12.1707C8.23838 12.9858 7.99514 13.9098 8.00007 14.8492C8.00501 15.7885 8.25797 16.7099 8.73334 17.5201",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanderConceptIconPanels);
export default __webpack_public_path__ + "static/media/lander-concept-icon-panels.f1031bdace136f265b039e589772b433.svg";
export { ForwardRef as ReactComponent };